import { IMask } from 'react-imask';
import _ from 'lodash';
import { getInitConfig } from 'ziphy-web-shared';
import { localStore } from 'ziphy-web-shared/basic/utils';
import { PHONE_COUNTRIES, PHONE_COUNTRIES_MAP, } from './PhoneInput.constants';
export const getPhoneConfigByCountry = (country = getInitConfig().phone.preferred[0]) => {
    return PHONE_COUNTRIES.find((x) => x.iso2 === country);
};
export const getPhoneConfigByAreaCode = (phoneConfig, value) => {
    const phoneNumber = value.replace(`+${phoneConfig.dialCode} `, '').replace(/\D/g, '');
    if (phoneNumber) {
        return PHONE_COUNTRIES_MAP[phoneConfig.dialCode].find((item) => item.areaCodes.some((areaCode) => phoneNumber.startsWith(areaCode)));
    }
};
export const getPhoneConfigByInputValue = (value, withDefault = false) => {
    let phoneConfig = withDefault ? getPhoneConfigByCountry(localStore.get('country', 'us')) : null;
    if (!_.isEmpty(value)) {
        let mostWanted = null;
        let mostWantedPrefix = '';
        let cleanPhone = value.replace(/\D/g, '');
        PHONE_COUNTRIES.forEach((country) => {
            const code = country.dialCode;
            const inners = country.areaCodes;
            if (cleanPhone.indexOf(code) === 0) {
                if (mostWantedPrefix && mostWantedPrefix.length > code.length) {
                    return true;
                }
                mostWantedPrefix = code;
                mostWanted = country;
                if (inners) {
                    inners.forEach((inner) => {
                        const combined = code.toString() + '' + inner.toString();
                        if (cleanPhone.indexOf(combined) === 0) {
                            if (mostWantedPrefix && mostWantedPrefix.length > combined.length) {
                                return true;
                            }
                            mostWantedPrefix = combined;
                            mostWanted = country;
                        }
                    });
                }
            }
        });
        if (mostWanted) {
            phoneConfig = mostWanted;
        }
    }
    return phoneConfig;
};
export const getFilteredCountries = (props = {}) => {
    const { only = [], preferred = [], excluded = [], usedField = 'iso2' } = props;
    let result = PHONE_COUNTRIES;
    if (only.length) {
        result = PHONE_COUNTRIES.filter((x) => only.includes(x[usedField]));
    }
    if (preferred.length) {
        let tmp = [];
        let toPreferred = [];
        let toOther = [];
        result.forEach((item) => {
            if (preferred.includes(item[usedField])) {
                tmp.push(Object.assign(Object.assign({}, item), { preferred: true }));
            }
            else {
                toOther.push(Object.assign(Object.assign({}, item), { preferred: false }));
            }
        });
        preferred.forEach((preferredItem) => {
            const found = tmp.find((x) => x[usedField] === preferredItem);
            if (found) {
                toPreferred.push(found);
            }
        });
        result = [...toPreferred, ...toOther];
    }
    if (excluded.length) {
        result = result.filter((x) => !excluded.includes(x[usedField]));
    }
    return result;
};
export const isEmptyPhoneNumber = (value) => {
    const onlyDigits = value.replace(/\D/g, '');
    return onlyDigits.length === 0 || Boolean(PHONE_COUNTRIES_MAP[onlyDigits]);
};
const checkByMask = (value, mask) => {
    let vLength = value.length;
    let pLength = mask.replace(/[^.]/g, '').length;
    return vLength >= pLength || (pLength >= 11 && vLength >= 7);
};
export const isValidPhoneNumber = (value) => {
    const phoneConfig = getPhoneConfigByInputValue(value);
    if (!phoneConfig) {
        return false;
    }
    return checkByMask(value.replace(`+${phoneConfig.dialCode} `, '').replace(/\D/g, ''), phoneConfig.mask || getInitConfig().phone.defaultMask);
};
export const getPhoneNumberDetails = (value) => {
    const phoneConfig = getPhoneConfigByInputValue(value);
    if (!phoneConfig) {
        return {
            country: '',
            number: '',
            numberClear: '',
            prefix: '',
            mask: '',
            formatted: '',
            formattedClear: '',
        };
    }
    const prefix = '+' + phoneConfig.dialCode;
    const mask = phoneConfig.mask || getInitConfig().phone.defaultMask;
    const number = value.replace(/\D/g, '').slice(phoneConfig.dialCode.length);
    const masked = IMask.createMask({ mask, definitions: { '.': /[0-9]/ } });
    const formatted = masked.resolve(number);
    return {
        country: phoneConfig.iso2,
        number: value,
        numberClear: number,
        prefix: prefix,
        mask: mask,
        formatted: prefix + ' ' + formatted,
        formattedClear: formatted,
    };
};
